import { resolveDestination } from "utils/notificationNavRegistry";

const NUMERIC = /^\d+$/;

/** FCM data is string-only; the nav registry expects the ids and flags the API would have sent. */
const restoreType = (value) => {
  if (typeof value !== "string") return value;
  if (NUMERIC.test(value)) return Number(value);
  if (value === "true") return true;
  if (value === "false") return false;
  return value;
};

export const notificationFromPushData = (data = {}) => {
  const { notificationId, type, tag, ...rest } = data;
  const metadata = Object.fromEntries(Object.entries(rest).map(([k, v]) => [k, restoreType(v)]));
  return { id: restoreType(notificationId), type, tag, clientId: metadata.clientId, metadata };
};

const notificationListFor = (pathname = "") =>
  pathname.startsWith("/partner") ? "/partner/notifications" : "/admin/notifications";

/** Where tapping a push should land: the screen its type maps to, else the portal's notification list. */
export const resolvePushDestination = (data, pathname) =>
  resolveDestination(notificationFromPushData(data)) ?? { path: notificationListFor(pathname) };
